import { useEffect, useState } from 'react'

// Below Tailwind's md breakpoint.
const NARROW_SCREEN_QUERY = '(max-width: 767px)'

export const useIsNarrowScreen = () => {
  const [isNarrow, setIsNarrow] = useState(
    () => window.matchMedia(NARROW_SCREEN_QUERY).matches,
  )

  useEffect(() => {
    const query = window.matchMedia(NARROW_SCREEN_QUERY)
    const update = () => setIsNarrow(query.matches)
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [])

  return isNarrow
}
